import { Route, Routes } from 'react-router-dom';

import RouteWithTitle from '../../../../../src/routes/RouteWithTitle';
import { AccessControl } from '../../../../components';
import {
  PremiumJobBoardsAction,
  useJobBoardAccessControl,
} from '../../../../hooks/useJobBoardAccessControl';
import { Loader } from '../../../conversationWidget/components/Loader';
import CareerBuilderJobBoard from '../careerBuilderJobBoard/CareerBuilderJobBoard';
import CareerBuilderNewAccount from '../careerBuilderJobBoard/CareerBuilderNewAccount';
import { CWJobsPostingJobBoard, CWJobsPostingNewAccount } from '../cwJobspostingJobBoard';
import DiceJobBoard from '../diceJobBoard/DiceJobBoard';
import DiceNewAccount from '../diceJobBoard/DiceNewAccount';
import FreeJobBoardSetting from '../freeJobBoardSetting';
import MonsterJobBoard from '../monsterJobBoard/MonsterJobBoard';
import MonsterNewAccount from '../monsterJobBoard/MonsterNewAccount';
import TechFetchJobBoard from '../techFetchJobBoard/TechFetchJobBoard';
import TechFetchNewAccount from '../techFetchJobBoard/TechFetchNewAccount';

export const JobBoardRoutes = () => {
  const { access, owns } = useJobBoardAccessControl([
    PremiumJobBoardsAction.VIEW_PREMIUM_JOB_POSTING_ACCOUNTS,
    PremiumJobBoardsAction.MANAGE_PREMIUM_JOB_POSTING_CREDITS,
    PremiumJobBoardsAction.DELETE_PREMIUM_JOB_POSTING_ACCOUNTS,
  ]);
  const [view, manage, deleteJobBoard] = access;
  const hasAccess = owns || view || manage || deleteJobBoard;
  const canManage = owns || manage;
  return (
    <Routes>
      <Route
        path="/"
        element={
          <RouteWithTitle title="Job Board Configuratons - Wisestep">
            <FreeJobBoardSetting />
          </RouteWithTitle>
        }
      />
      <Route
        path="/monster"
        element={
          hasAccess == undefined ? <Loader /> : hasAccess ? <MonsterJobBoard /> : <AccessControl />
        }
      />
      <Route
        path="/dice"
        element={
          hasAccess == undefined ? <Loader /> : hasAccess ? <DiceJobBoard /> : <AccessControl />
        }
      />
      <Route
        path="/careerBuilder"
        element={
          hasAccess == undefined ? (
            <Loader />
          ) : hasAccess ? (
            <CareerBuilderJobBoard />
          ) : (
            <AccessControl />
          )
        }
      />
      <Route
        path="/techFetch"
        element={
          hasAccess == undefined ? (
            <Loader />
          ) : hasAccess ? (
            <TechFetchJobBoard />
          ) : (
            <AccessControl />
          )
        }
      />
      <Route
        path="/cwJobs-jobposting"
        element={
          hasAccess == undefined ? (
            <Loader />
          ) : hasAccess ? (
            <CWJobsPostingJobBoard />
          ) : (
            <AccessControl />
          )
        }
      />

      <Route
        path="/monster-add"
        element={
          canManage == undefined ? (
            <Loader />
          ) : canManage ? (
            <MonsterNewAccount />
          ) : (
            <AccessControl />
          )
        }
      />
      <Route
        path="/dice-add"
        element={
          canManage == undefined ? <Loader /> : canManage ? <DiceNewAccount /> : <AccessControl />
        }
      />
      <Route
        path="/careerBuilder-add"
        element={
          canManage == undefined ? (
            <Loader />
          ) : canManage ? (
            <CareerBuilderNewAccount />
          ) : (
            <AccessControl />
          )
        }
      />
      <Route
        path="/techFetch-add"
        element={
          canManage == undefined ? (
            <Loader />
          ) : canManage ? (
            <TechFetchNewAccount />
          ) : (
            <AccessControl />
          )
        }
      />
      <Route
        path="/cwJobs-jobposting-add"
        element={
          canManage == undefined ? (
            <Loader />
          ) : canManage ? (
            <CWJobsPostingNewAccount />
          ) : (
            <AccessControl />
          )
        }
      />
    </Routes>
  );
};
